import { patientAbsenceDTO } from '@/modules/schedule/domain/models/PatientAbsenceModel'

import { axios, Response } from '../index'

export const declarePatientAbsence = (
  body: patientAbsenceDTO
): Response<void> => {
  return axios.put(`/v1/sessions-absence`, body)
}
